import React from 'react';
import { Navbar, Button, OverlayTrigger, Popover } from 'react-bootstrap'; 
import { Person, List } from 'react-bootstrap-icons'; // Import List icon
import './Default.css';

function Header({ onToggleSidebar, onLogout }) {

  const handleLogout = () => {
    localStorage.removeItem('role');
    window.location.href = '/';  // Redirect to login page after logout
  };
  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        <Button variant="" className="text-dark" onClick={onLogout}>
          Logout
        </Button>
      </Popover.Body>
    </Popover>
  );

  return (
    <Navbar id='headerstyle' className=" p-2 d-flex justify-content-between">
      {/* Left Side - Title */}
      <div className="d-flex align-items-center">
        <Button variant="" className="me-2 d-lg-none" onClick={onToggleSidebar}>
          <List color="white" size={23} />
        </Button>
        <h3 className='text-white mx-4'>INVENTORY</h3>
      </div>

      {/* Right Side - Icons Section */}
      <div className='d-flex justify-content-end flex-column align-items-center'>
        <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
          <Button variant="" className="me-2">
            <Person color="white" size={23} />
          </Button>
        </OverlayTrigger>
      </div>
    </Navbar>
  );
}

export default Header;
